





















































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import ICountUp from "vue-countup-v2";
import "@/directives/directives";
import "@/styles/home.scss";

@Component({
  components: {
    ICountUp,
  },
})
export default class Home extends Vue {
  private show = 1;
  private nextSlide = 1;
  private currentAnimating = 1;
  private intervalId = 0;

  options = {
    useEasing: true,
    useGrouping: true,
    separator: ",",
    decimal: ".",
    prefix: "",
    duration: 8,
    suffix: "",
  };

  private handle(x: number) {
    this.slide(x);
    if (this.intervalId !== -1) clearInterval(this.intervalId);
    this.intervalId = -1;
  }

  private slide(x: number) {
    this.show = 0;
    this.nextSlide = x;
  }

  private invokeNext() {
    this.show = this.nextSlide;
    this.currentAnimating = this.nextSlide;
  }

  mounted() {
    this.intervalId = setInterval(() => {
      let x = this.nextSlide + 1;
      if (x == 4) x = 1;

      this.slide(x);
    }, 4500);
  }
}
